module.exports = __webpack_public_path__ + "img/ep-hexagone.bca06e38.jpg";